var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return !_vm.isResellerSubAccount
    ? _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 mb-5"
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                size: "24",
                                color: "primary"
                              }
                            },
                            [_vm._v("mdi-account-settings")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "ml-2"
                            },
                            [_vm._v(_vm._s(_vm.serviceInfoTitle))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            [
                              !_vm.isResellerSubAccount
                                ? _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-subtitle", [
                                        _c("strong", [_vm._v("Plan Type")])
                                      ]),
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.hosting.name) + " "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "medium"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.iconFlag(
                                                      _vm.hosting.flag
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _vm.hosting.changeplan
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "d-block",
                                                  attrs: {
                                                    href: "#"
                                                  },
                                                  on: {
                                                    click: function click(
                                                      $event
                                                    ) {
                                                      $event.preventDefault()
                                                      return _vm.handleChangePlan(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(" Change Plan ")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-subtitle", [
                                    _c("strong", [_vm._v("Status")])
                                  ]),
                                  _c(
                                    "v-list-item-title",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pb-1",
                                          attrs: {
                                            small: "",
                                            color: _vm.statusColor(
                                              _vm.hosting.status
                                            )
                                          }
                                        },
                                        [_vm._v("mdi-circle")]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.hosting.status) + " "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              !_vm.isResellerSubAccount
                                ? _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-subtitle", [
                                        _c("strong", [_vm._v("Billing Cycle")])
                                      ]),
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(_vm.hosting.renewalterm))
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-subtitle", [
                                    _c("strong", [_vm._v("Renewal Date")])
                                  ]),
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRenewalDate(
                                            _vm.parseRenewalDate(
                                              _vm.hosting.renewaldate
                                            )
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider", {
                            staticClass: "my-0"
                          }),
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-subtitle", [
                                    _c("strong", [
                                      _vm._v("Password Management")
                                    ])
                                  ]),
                                  _c(
                                    "v-list-item-title",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: _vm.changePasswordRoute
                                          }
                                        },
                                        [_vm._v(" Change Password ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              !_vm.isResellerSubAccount
                                ? _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-subtitle", [
                                        _c("strong", [
                                          _vm._v("Sharing Options")
                                        ])
                                      ]),
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _vm.hosting.sharedaccount ||
                                          _vm.hosting.sharedaccess
                                            ? _c("shared-service-tag", {
                                                attrs: {
                                                  service: _vm.hosting
                                                }
                                              })
                                            : _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "profile_access"
                                                    }
                                                  }
                                                },
                                                [_vm._v(" Enable Sharing ")]
                                              )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.currentHosting.cancellation_type === "addon"
                                ? _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-subtitle", [
                                        _c("strong", [
                                          _vm._v("Addon Cancellation")
                                        ])
                                      ]),
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: "/cancellations/".concat(
                                                  _vm.currentHosting
                                                    .cancellation_id
                                                ),
                                                "aria-label": "View Request"
                                              }
                                            },
                                            [_vm._v(" View Request ")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : !_vm.isResellerSubAccount
                                ? _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-subtitle", [
                                        _vm.currentHosting.autorenew
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " Auto Renew: Enabled "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " Auto Renew: Disabled "
                                                  )
                                                ]
                                              )
                                            ])
                                      ]),
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _vm.currentHosting.autorenew
                                            ? _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "cancel",
                                                      params: {
                                                        service_id:
                                                          _vm.hosting.id
                                                      },
                                                      query: {
                                                        type:
                                                          _vm.cancellationTypes
                                                            .HOSTING
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.hosting.status ===
                                                          "Suspended"
                                                          ? "Submit Cancellation"
                                                          : "Disable Auto-Renew"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "#"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.canAutorenewProceed
                                                  }
                                                },
                                                [_vm._v(" Enable Auto-Renew ")]
                                              )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("auto-renew-modal", {
                        ref: "autoRenewModal"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }